import { Link } from "react-router-dom";
import AdminHeader from "../../component/AdminHeader";
import { usePermissions } from "../../helper/PermissionContext";

export default function AccessDenied() {
  const { hasPermission } = usePermissions();
  const canViewDashboard = hasPermission("dashboard");

  return (
    <>
      <AdminHeader pagename={{ name: "Access Denied", user: "Admin", innerpage: "Access Denied" }} />
      <section className="access-denied-page">
        <div className="access-denied-panel">
          <div className="access-denied-icon">!</div>
          <h2>Access Denied</h2>
          <p>You do not have permission to view this page.</p>
          {canViewDashboard && (
            <Link to="/" className="default-btn">
              Go to Dashboard<span></span>
            </Link>
          )}
        </div>
      </section>
    </>
  );
}
